import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import { Loader } from "@/components/common";
import AuthPage from "@/pages/AuthPage";
import PasswordRecovery from "@/pages/PasswordRecovery";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Training from "@/pages/Training";
import Nutrition from "@/pages/Nutrition";
import Ailments from "@/pages/Ailments";
import Progress from "@/pages/Progress";
import Profile from "@/pages/Profile";
import Coach from "@/pages/Coach";
import Activities from "@/pages/Activities";
import Agenda from "@/pages/Agenda";
import Admin from "@/pages/Admin";

const Protected = ({ children, needsProfile = true }) => {
  const { me } = useAuth();
  if (me === null) return <Loader />;
  if (!me) return <Navigate to="/login" replace />;
  if (needsProfile && !me.onboarding_complete && me.role !== "admin") return <Navigate to="/bienvenida" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { me } = useAuth();
  return me?.role === "admin" ? children : <Navigate to="/" replace />;
};

const Public = ({ children }) => {
  const { me } = useAuth();
  if (me === null) return <Loader />;
  return me ? <Navigate to="/" replace /> : children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Public><AuthPage mode="login" /></Public>} />
            <Route path="/registro" element={<Public><AuthPage mode="register" /></Public>} />
            <Route path="/register" element={<Navigate to="/registro" replace />} />
            <Route path="/recuperar" element={<Public><PasswordRecovery mode="forgot" /></Public>} />
            <Route path="/nueva-contrasena" element={<Public><PasswordRecovery mode="reset" /></Public>} />
            <Route path="/bienvenida" element={<Protected needsProfile={false}><Onboarding /></Protected>} />
            <Route path="/admin" element={<Protected needsProfile={false}><AdminOnly><div className="mx-auto max-w-3xl px-4 py-8"><a href="/" className="text-sm font-semibold text-stone-500" data-testid="admin-back-link">← Volver</a><div className="mt-4"><Admin /></div></div></AdminOnly></Protected>} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/entrenador" element={<Training />} />
              <Route path="/dietista" element={<Nutrition />} />
              <Route path="/dolencias" element={<Ailments />} />
              <Route path="/progreso" element={<Progress />} />
              <Route path="/perfil" element={<Profile />} />
              <Route path="/coach" element={<Coach />} />
              <Route path="/actividad" element={<Activities />} />
              <Route path="/agenda" element={<Agenda />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
